/* ═══════════════════════════════════════════════════════════════════════════
   KANZI Online — 공용 인터랙션 (프로토타입 + Shopify 테마 공유)

   서버가 마크업을 렌더하고, 이 파일은 동작만 담당한다.
   전부 data-* 속성으로 위임 바인딩하므로 Liquid에서 마크업만 맞추면 그대로 붙는다.
   ═══════════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  'use strict';

  var $  = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ── 헤더 높이 → CSS 변수 (메가메뉴·sticky LNB 기준점) ───────────────── */
  function measure() {
    var h = $('[data-k-header]');
    if (h) d.documentElement.style.setProperty('--k-header-h', h.getBoundingClientRect().height + 'px');
    var s = $('[data-k-gallery] .k-pdp__slide');
    if (s) d.documentElement.style.setProperty('--k-gal-h', s.getBoundingClientRect().height + 'px');
  }
  w.kanziMeasure = measure;

  /* ── 가로 레일 (캐러셀) ──────────────────────────────────────────────── */
  function railScroll(rail, dir) {
    if (rail) rail.scrollBy({ left: dir * rail.clientWidth * 0.92, behavior: 'smooth' });
  }
  function bindRails(root) {
    $$('[data-k-rail-btn]', root).forEach(function (btn) {
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-k-rail-wrap]');
        railScroll(wrap && $('[data-k-rail]', wrap), btn.dataset.kRailBtn === 'prev' ? -1 : 1);
      });
    });
  }

  /* ── 히어로: 페이지 표시 + 오토플레이 ────────────────────────────────── */
  var heroTimer;
  function bindHero(root) {
    var rail = $('[data-k-hero-rail]', root);
    if (!rail) return;
    var num = $('[data-k-hero-cur]', root), bar = $('[data-k-hero-bar]', root);
    var n = rail.children.length || 1;
    function sync() {
      /* 레이아웃 전에는 scrollWidth 가 0 이라 나누면 NaN 이 된다 — 1번 슬라이드로 둔다 */
      var step = rail.scrollWidth / n;
      var cur = step > 0 ? Math.min(Math.round(rail.scrollLeft / step) + 1, n) : 1;
      if (num) num.textContent = String(cur).padStart(2, '0');
      if (bar) bar.style.width = (cur / n * 100) + '%';
    }
    rail.addEventListener('scroll', sync);
    w.addEventListener('resize', sync);
    w.addEventListener('load', sync);
    sync();
    clearInterval(heroTimer);
    heroTimer = setInterval(function () {
      if (!d.body.contains(rail)) return clearInterval(heroTimer);
      if (rail.matches(':hover')) return;
      if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else railScroll(rail, 1);
    }, 5200);
  }

  /* ── 상단 프로모션 띠 롤링 ───────────────────────────────────────────── */
  var topTimer;
  function bindTopbar(root) {
    var slides = $$('[data-k-topbar] .k-topbar__slide', root);
    if (slides.length < 2) return;
    var i = 0;
    clearInterval(topTimer);
    topTimer = setInterval(function () {
      if (!d.body.contains(slides[0])) return clearInterval(topTimer);
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, 4400);
    var x = $('[data-k-topbar-close]', root);
    if (x) x.addEventListener('click', function () {
      var bar = x.closest('[data-k-topbar]'); if (bar) bar.style.display = 'none'; measure();
    });
  }

  /* ── 탭 ──────────────────────────────────────────────────────────────
     같은 [data-k-tabs] 안의 버튼 index ↔ [data-k-tabpanel] index 를 맞춘다.
     is-on 은 버튼과 (있다면) 부모 li 양쪽에 건다 — 홈 섹션은 li 안에,
     PDP 하단 탭은 li 없이 버튼만 있기 때문.
     ------------------------------------------------------------------ */
  function markTab(btn, on) {
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-selected', on ? 'true' : 'false');
    if (btn.parentNode && btn.parentNode.tagName === 'LI') btn.parentNode.classList.toggle('is-on', on);
  }
  function bindTabs(root) {
    $$('[data-k-tabs]', root).forEach(function (grp) {
      if (grp.dataset.kBound) return;
      grp.dataset.kBound = '1';
      var items  = $$('[data-k-tab]', grp);
      var panels = $$('[data-k-tabpanel]', grp);
      items.forEach(function (btn, idx) {
        btn.setAttribute('role', 'tab');
        btn.addEventListener('click', function () {
          items.forEach(function (b, k) { markTab(b, k === idx); });
          panels.forEach(function (p, k) { p.hidden = k !== idx; });
          if (typeof w.kanziOnTab === 'function') w.kanziOnTab(grp, idx);
          bindRails(grp); bindWish(grp);
        });
      });
      items.forEach(function (b, k) { markTab(b, k === 0); });
      panels.forEach(function (p, k) { p.hidden = k !== 0; });
    });
  }

  /* ── 아코디언 ────────────────────────────────────────────────────────── */
  function bindAccordion(root) {
    $$('[data-k-acc-toggle]', root).forEach(function (btn) {
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.k-acc__item'); if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ── PDP 갤러리 카운터 ───────────────────────────────────────────────── */
  function bindGallery(root) {
    var g = $('[data-k-gallery]', root); if (!g) return;
    var rail = $('[data-k-rail]', g), cur = $('[data-k-gal-cur]', g);
    if (!rail || !cur) return;
    var n = rail.children.length || 1;
    function sync() {
      /* 히어로와 같은 함정 — 레이아웃·이미지 로드 전에는 scrollWidth 가 0 이라
         나누면 NaN 이 되어 카운터에 "NaN / 5" 가 찍힌다. 그때는 1번으로 둔다. */
      var step = rail.scrollWidth / n;
      var i = step > 0 ? Math.min(Math.round(rail.scrollLeft / step) + 1, n) : 1;
      cur.textContent = String(i).padStart(2, '0');
    }
    rail.addEventListener('scroll', sync);
    w.addEventListener('resize', sync);
    w.addEventListener('load', sync);
    sync();
  }

  /* ── 상품 옵션 선택 ──────────────────────────────────────────────────── */
  function bindOptions(root) {
    $$('[data-k-opt]', root).forEach(function (btn) {
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        $$('button', btn.parentNode).forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        var input = d.getElementById(btn.dataset.kOptTarget || '');
        if (input) { input.value = btn.dataset.kOptValue || btn.textContent.trim(); input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }

  /* ── 메가메뉴 / 검색 / 장바구니 / 딤 ─────────────────────────────────── */
  function closeAll() {
    $$('[data-k-mega],[data-k-search],[data-k-cart],[data-k-dim]').forEach(function (el) { el.classList.remove('is-open'); });
  }
  w.kanziCloseAll = closeAll;

  function bindOverlays(root) {
    var openers = [['[data-k-mega-toggle]', '[data-k-mega]', false],
                   ['[data-k-search-open]', '[data-k-search]', true],
                   ['[data-k-cart-open]',   '[data-k-cart]',   true]];
    openers.forEach(function (o) {
      $$(o[0], root).forEach(function (btn) {
        if (btn.dataset.kBound) return;
        btn.dataset.kBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var panel = $(o[1]); if (!panel) return;
          var willOpen = !panel.classList.contains('is-open');
          closeAll();
          if (willOpen) {
            panel.classList.add('is-open');
            if (o[2]) { var dim = $('[data-k-dim]'); if (dim) dim.classList.add('is-open'); }
            var inp = $('input[type="search"],input[type="text"]', panel);
            if (inp && o[0].indexOf('search') > -1) setTimeout(function () { inp.focus(); }, 220);
          }
        });
      });
    });
    $$('[data-k-dim],[data-k-close]', root).forEach(function (el) {
      if (el.dataset.kBound) return;
      el.dataset.kBound = '1';
      el.addEventListener('click', closeAll);
    });
    // 메가메뉴 dep1 hover
    $$('[data-k-mega-dep1]', root).forEach(function (btn) {
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('mouseenter', function () {
        var i = btn.dataset.kMegaDep1;
        $$('[data-k-mega-dep1]').forEach(function (b) { b.parentNode.classList.toggle('is-on', b.dataset.kMegaDep1 === i); });
        $$('[data-k-mega-dep2]').forEach(function (p) { p.hidden = p.dataset.kMegaDep2 !== i; });
      });
    });
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ── 카드에서 바로 담기 (Shopify Ajax Cart) ─────────────────────────── */
  function bindQuickAdd(root) {
    $$('[data-k-quickadd]', root).forEach(function (btn) {
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.dataset.kQuickadd;
        if (!id || btn.disabled) return;
        var label = btn.innerHTML;
        btn.disabled = true; btn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'error');
            toast('장바구니에 담았습니다');
            return refreshCartCount();
          })
          .catch(function (err) { toast(String(err.message || err).slice(0, 60)); })
          .then(function () { btn.disabled = false; btn.innerHTML = label; });
      });
    });
  }

  /* 헤더 장바구니 수량 갱신 */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.k-header__count').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }
  w.kanziRefreshCart = refreshCartCount;

  /* ── 찜 (로컬 저장) ──────────────────────────────────────────────────── */
  var WISH_KEY = 'kanzi_wish';
  function wishSet() { try { return new Set(JSON.parse(localStorage.getItem(WISH_KEY) || '[]')); } catch (e) { return new Set(); } }
  function bindWish(root) {
    var set = wishSet();
    $$('[data-k-wish]', root).forEach(function (btn) {
      btn.classList.toggle('is-on', set.has(btn.dataset.kWish));
      if (btn.dataset.kBound) return;
      btn.dataset.kBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = wishSet(), id = btn.dataset.kWish;
        s.has(id) ? s.delete(id) : s.add(id);
        localStorage.setItem(WISH_KEY, JSON.stringify(Array.from(s)));
        $$('[data-k-wish="' + id + '"]').forEach(function (b) { b.classList.toggle('is-on', s.has(id)); });
        toast(s.has(id) ? '찜한 상품에 담았습니다' : '찜을 해제했습니다');
      });
    });
  }

  /* ── 토스트 ──────────────────────────────────────────────────────────── */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-k-toast]');
    if (!el) { el = d.createElement('div'); el.className = 'k-toast'; el.setAttribute('data-k-toast', ''); d.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 1900);
  }
  w.kanziToast = toast;

  /* ── 초기화 (Shopify 섹션 재렌더에도 안전하게 재호출 가능) ───────────── */
  function init(root) {
    root = root || d;
    bindRails(root); bindHero(root); bindTopbar(root); bindTabs(root);
    bindAccordion(root); bindGallery(root); bindOptions(root);
    bindOverlays(root); bindWish(root); bindQuickAdd(root); measure();
  }
  w.kanziInit = init;

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  w.addEventListener('resize', measure);
  // Shopify 테마 에디터에서 섹션을 다시 그릴 때
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})(window, document);
